import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { Reducer } from 'redux';
import { GetAvailableYearsByIssuerIdState, GetAvailableYearsByIssuerIdTypes } from './types';

const initialState: GetAvailableYearsByIssuerIdState = {
    status: HttpRequestStatus.NOOP,
    years: undefined,
    error: undefined
};

const reducer: Reducer<GetAvailableYearsByIssuerIdState> = (state = initialState, action): GetAvailableYearsByIssuerIdState => {
    switch (action.type) {
        case GetAvailableYearsByIssuerIdTypes.GET_AVAILABLE_YEARS_BY_ISSUER_ID_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, error: undefined };
        }
        case GetAvailableYearsByIssuerIdTypes.GET_AVAILABLE_YEARS_BY_ISSUER_ID_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, years: action.payload, error: undefined };
        }
        case GetAvailableYearsByIssuerIdTypes.GET_AVAILABLE_YEARS_BY_ISSUER_ID_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case GetAvailableYearsByIssuerIdTypes.GET_AVAILABLE_YEARS_BY_ISSUER_ID_RESET_STATE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export { reducer as getAvailableYearsByIssuerIdReducer };
